// extracted by mini-css-extract-plugin
export default {"inputBlock":"formStyle_inputBlock__1AStY","textMuted":"formStyle_textMuted__0E1gl"};